import { post } from "storefront/GrailedAPI/request";
import { Id } from "storefront/lib/Id";

const acknowledgeViolation = (userId: Id): Promise<void> => {
  return post(`/api/users/${userId}/acknowledge_violation`);
};

export default acknowledgeViolation;
